import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TypeFeedbackCategory, TypeInitialState } from '@widgets/Common/ModalFeedback/model/types'

const initialState: TypeInitialState = {
  opened: false,
  category: null,
  preselectedCategory: false,
  loading: false,
  prefilled_data: {
    full_name: null,
    email: null,
  },
}

const FeedbackReduce = createSlice({
  name: 'feedback',
  initialState,
  reducers: {
    setOpened: (state, action: PayloadAction<boolean>) => {
      state.opened = action.payload
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setCategory: (state, action: PayloadAction<TypeFeedbackCategory>) => {
      state.category = action.payload
    },
    resetCategory: (state) => {
      state.category = null
    },
    setPreselectedCategory: (state, action: PayloadAction<boolean>) => {
      state.preselectedCategory = action.payload
    },
    setPrefilledData: (state, action: PayloadAction<{ full_name?: string; email?: string }>) => {
      state.prefilled_data = {
        ...state.prefilled_data,
        ...action.payload,
      }
    },
    setInitState: (state) => {
      return initialState
    },
  },
})

export const {
  setOpened,
  setCategory,
  resetCategory,
  setPreselectedCategory,
  setLoading,
  setPrefilledData,
  setInitState,
} = FeedbackReduce.actions

export default FeedbackReduce.reducer
